// Generated by scripts/content/convert-content-to-json.mjs. Do not edit by hand.
// Static imports: Metro cannot resolve a dynamic require path at runtime.
// `data` stays `unknown` so the loader validates it before the registry
// sees it, and so TypeScript need not infer 174 JSON literal shapes.
// The order below is the module load order the registry depended on.

import dataTestingSemenAnalysis from "./testing/semen-analysis.json";
import dataTestingAmh from "./testing/amh.json";
import dataTestingPgtA from "./testing/pgt-a.json";
import dataTestingPgtAProducts from "./testing/pgt-a-products.json";
import dataTestingEra from "./testing/era.json";
import dataTestingWholeGenome from "./testing/whole-genome.json";
import dataTestingFertilityTracker from "./testing/fertility-tracker.json";
import dataTestingMonitoringUltrasound from "./testing/monitoring-ultrasound.json";
import dataTestingBaselineUltrasound from "./testing/baseline-ultrasound.json";
import dataTestingGeneralBloodwork from "./testing/general-bloodwork.json";
import dataTestingComprehensiveBiomarkerPanel from "./testing/comprehensive-biomarker-panel.json";
import dataTestingBetaHcgTest from "./testing/beta-hcg-test.json";
import dataTestingProgesteroneCheck from "./testing/progesterone-check.json";
import dataTestingSalineSonogram from "./testing/saline-sonogram.json";
import dataTestingLiningCheck from "./testing/lining-check.json";
import dataTestingThyroidPanel from "./testing/thyroid-panel.json";
import dataTestingProlactin from "./testing/prolactin.json";
import dataTestingFshTest from "./testing/fsh-test.json";
import dataTestingLhTest from "./testing/lh-test.json";
import dataTestingEstradiolTest from "./testing/estradiol-test.json";
import dataTestingVitaminD from "./testing/vitamin-d.json";
import dataTestingCbc from "./testing/cbc.json";
import dataTestingInfectiousDiseasePanel from "./testing/infectious-disease-panel.json";
import dataTestingThrombophiliaPanel from "./testing/thrombophilia-panel.json";
import dataTestingKaryotype from "./testing/karyotype.json";
import dataTestingCarrierScreening from "./testing/carrier-screening.json";
import dataTestingPreimplantationGeneticTesting from "./testing/preimplantation-genetic-testing.json";
import dataTestingPgtM from "./testing/pgt-m.json";
import dataTestingPgtSr from "./testing/pgt-sr.json";
import dataTestingPgtP from "./testing/pgt-p.json";
import dataTestingEmma from "./testing/emma.json";
import dataTestingAlice from "./testing/alice.json";
import dataTestingEndometrio from "./testing/endometrio.json";
import dataTestingAfc from "./testing/afc.json";
import dataTestingFertilityDataPoints from "./testing/fertility-data-points.json";
import dataTestingFr from "./testing/fr.json";
import dataOptimizationEggQuality from "./optimization/egg-quality.json";
import dataOptimizationSpermOptimization from "./optimization/sperm-optimization.json";
import dataOptimizationSupplements from "./optimization/supplements.json";
import dataOptimizationAlphasperm from "./optimization/alphasperm.json";
import dataOptimizationSupplementsFr from "./optimization/supplements.fr.json";
import dataOptimizationTherapies from "./optimization/therapies.json";
import dataPrepFromCouch from "./prep/from-couch.json";
import dataPrepAtLab from "./prep/at-lab.json";
import dataPrepAtClinic from "./prep/at-clinic.json";
import dataProductsAtHomeTests from "./products/at-home-tests.json";
import dataProgramModulesFemaleHormoneBaseline from "./program-modules/female-hormone-baseline.json";
import dataProgramModulesMaleFertilityBaseline from "./program-modules/male-fertility-baseline.json";
import dataProgramModulesFemaleOptimization from "./program-modules/female-optimization.json";
import dataProgramModulesMaleOptimization from "./program-modules/male-optimization.json";
import dataProgramModulesOvarianStimulation from "./program-modules/ovarian-stimulation.json";
import dataProgramModulesEggRetrieval from "./program-modules/egg-retrieval.json";
import dataProgramModulesFertilizationCulture from "./program-modules/fertilization-culture.json";
import dataProgramModulesPgtAScreening from "./program-modules/pgt-a-screening.json";
import dataProgramModulesEmbryoTransfer from "./program-modules/embryo-transfer.json";
import dataProgramModulesIuiProcedure from "./program-modules/iui-procedure.json";
import dataProgramModulesTwwSupport from "./program-modules/tww-support.json";
import dataProgramModulesGeneticCarrier from "./program-modules/genetic-carrier.json";
import dataProgramModulesComprehensiveGenomic from "./program-modules/comprehensive-genomic.json";
import dataProgramModulesComprehensiveWellness from "./program-modules/comprehensive-wellness.json";
import dataProgramModulesFr from "./program-modules/fr.json";
import dataProgramsFertilityCheckIn from "./programs/fertility-check-in.json";
import dataProgramsHerOptimization from "./programs/her-optimization.json";
import dataProgramsHisOptimization from "./programs/his-optimization.json";
import dataProgramsCouplesOptimization from "./programs/couples-optimization.json";
import dataProgramsEggFreezing from "./programs/egg-freezing.json";
import dataProgramsEmbryoFreezing from "./programs/embryo-freezing.json";
import dataProgramsIvfCycle from "./programs/ivf-cycle.json";
import dataProgramsIuiCycle from "./programs/iui-cycle.json";
import dataProgramsFetCycle from "./programs/fet-cycle.json";
import dataProgramsGeneticScreening from "./programs/genetic-screening.json";
import dataProgramsFullAssessment from "./programs/full-assessment.json";
import dataProgramsFr from "./programs/fr.json";
import dataProceduresHsg from "./procedures/hsg.json";
import dataProceduresInitialConsult from "./procedures/initial-consult.json";
import dataProceduresFollowUpConsult from "./procedures/follow-up-consult.json";
import dataProceduresGeneticCounseling from "./procedures/genetic-counseling.json";
import dataProceduresTriggerShot from "./procedures/trigger-shot.json";
import dataProceduresIui from "./procedures/iui.json";
import dataProceduresMiniIvf from "./procedures/mini-ivf.json";
import dataProceduresMockTransfer from "./procedures/mock-transfer.json";
import dataProceduresEndometrialBiopsy from "./procedures/endometrial-biopsy.json";
import dataProceduresSpermFreeze from "./procedures/sperm-freeze.json";
import dataProceduresOvarianStimulation from "./procedures/ovarian-stimulation.json";
import dataProceduresEggRetrieval from "./procedures/egg-retrieval.json";
import dataProceduresEmbryoTransfer from "./procedures/embryo-transfer.json";
import dataProceduresFrozenEmbryoTransfer from "./procedures/frozen-embryo-transfer.json";
import dataProceduresEndometrialPreparation from "./procedures/endometrial-preparation.json";
import dataProceduresLutealSupport from "./procedures/luteal-support.json";
import dataProceduresTwoWeekWait from "./procedures/two-week-wait.json";
import dataProceduresFertilizationIcsi from "./procedures/fertilization-icsi.json";
import dataProceduresEmbryoCulture from "./procedures/embryo-culture.json";
import dataProceduresEmbryoBiopsyPgt from "./procedures/embryo-biopsy-pgt.json";
import dataProceduresCryopreservation from "./procedures/cryopreservation.json";
import dataProceduresSpermCollection from "./procedures/sperm-collection.json";
import dataProceduresHysteroscopy from "./procedures/hysteroscopy.json";
import dataProceduresLaparoscopy from "./procedures/laparoscopy.json";
import dataProceduresTese from "./procedures/tese.json";
import dataProceduresAssistedHatching from "./procedures/assisted-hatching.json";
import dataProceduresMyomectomy from "./procedures/myomectomy.json";
import dataProceduresPolypectomy from "./procedures/polypectomy.json";
import dataProceduresEndometrialScratch from "./procedures/endometrial-scratch.json";
import dataProceduresHormonalTesting from "./procedures/hormonal-testing.json";
import dataProceduresStdTesting from "./procedures/std-testing.json";
import dataProceduresThyroidTesting from "./procedures/thyroid-testing.json";
import dataProceduresUrinalysis from "./procedures/urinalysis.json";
import dataProceduresTransabdominalUltrasound from "./procedures/transabdominal-ultrasound.json";
import dataProceduresTransvaginalUltrasound from "./procedures/transvaginal-ultrasound.json";
import dataProceduresDopplerUltrasound from "./procedures/doppler-ultrasound.json";
import dataProceduresHysterosonography from "./procedures/hysterosonography.json";
import dataProceduresAntralFollicleCount from "./procedures/antral-follicle-count.json";
import dataProceduresPelvicMri from "./procedures/pelvic-mri.json";
import dataProceduresKaryotyping from "./procedures/karyotyping.json";
import dataProceduresCarrierTesting from "./procedures/carrier-testing.json";
import dataProceduresExomeGenomeSequencing from "./procedures/exome-genome-sequencing.json";
import dataProceduresSwabTest from "./procedures/swab-test.json";
import dataProceduresPapSmear from "./procedures/pap-smear.json";
import dataProceduresSurgicalSpermRetrieval from "./procedures/surgical-sperm-retrieval.json";
import dataProceduresTesticularBiopsy from "./procedures/testicular-biopsy.json";
import dataMoonArticles from "./moon-articles.json";
import dataMoonArticlesFr from "./moon-articles.fr.json";
import dataMoonArticlesGuides from "./moon-articles-guides.json";
import dataMoonArticlesGuidesFr from "./moon-articles-guides.fr.json";
import dataMoonArticlesDonor from "./moon-articles-donor.json";
import dataMoonArticlesDonorFr from "./moon-articles-donor.fr.json";
import dataMoonArticlesDecisions from "./moon-articles-decisions.json";
import dataMoonArticlesDecisionsFr from "./moon-articles-decisions.fr.json";
import dataMoonArticlesScience from "./moon-articles-science.json";
import dataMoonArticlesScienceFr from "./moon-articles-science.fr.json";
import dataMoonArticlesCosts from "./moon-articles-costs.json";
import dataMoonArticlesCostsFr from "./moon-articles-costs.fr.json";
import dataMoonArticlesCountryGuides from "./moon-articles-country-guides.json";
import dataMoonArticlesCountryGuidesFr from "./moon-articles-country-guides.fr.json";
import dataMoonArticlesTravel from "./moon-articles-travel.json";
import dataMoonArticlesTravelFr from "./moon-articles-travel.fr.json";
import dataNewArticlesBatch1 from "./new-articles-batch1.json";
import dataNewArticlesBatch1Fr from "./new-articles-batch1.fr.json";
import dataNewArticlesBatch2 from "./new-articles-batch2.json";
import dataNewArticlesBatch2Fr from "./new-articles-batch2.fr.json";
import dataNewArticlesBatch3 from "./new-articles-batch3.json";
import dataNewArticlesBatch3Fr from "./new-articles-batch3.fr.json";
import dataNewArticlesBatch4 from "./new-articles-batch4.json";
import dataNewArticlesBatch4Fr from "./new-articles-batch4.fr.json";
import dataMedicationsGonadotropins from "./medications/gonadotropins.json";
import dataMedicationsGnrhAntagonists from "./medications/gnrh-antagonists.json";
import dataMedicationsGnrhAgonists from "./medications/gnrh-agonists.json";
import dataMedicationsTriggerShots from "./medications/trigger-shots.json";
import dataMedicationsProgesteroneSupport from "./medications/progesterone-support.json";
import dataMedicationsEstrogen from "./medications/estrogen.json";
import dataMedicationsOralOvulation from "./medications/oral-ovulation.json";
import dataMedicationsAnticoagulants from "./medications/anticoagulants.json";
import dataMedicationsOther from "./medications/other.json";
import dataMedicationsGrowthHormone from "./medications/growth-hormone.json";
import dataMedicationsDexamethasone from "./medications/dexamethasone.json";
import dataMedicationsThyroidSupport from "./medications/thyroid-support.json";
import dataMedicationsBromocriptine from "./medications/bromocriptine.json";
import dataMedicationsTamoxifen from "./medications/tamoxifen.json";
import dataMedicationsIntralipid from "./medications/intralipid.json";
import dataMedicationsCycleControl from "./medications/cycle-control.json";
import dataMedicationsImmune from "./medications/immune.json";
import dataMedicationsGlp1 from "./medications/glp1.json";
import dataMedicationsWarfarin from "./medications/warfarin.json";
import dataMedicationsFolicAcid from "./medications/folic-acid.json";
import dataConditionsReproductive from "./conditions/reproductive.json";
import dataConditionsEndocrine from "./conditions/endocrine.json";
import dataConditionsStructural from "./conditions/structural.json";
import dataConditionsMaleFactor from "./conditions/male-factor.json";
import dataConditionsAutoimmune from "./conditions/autoimmune.json";
import dataConditionsMullerian from "./conditions/mullerian.json";
import dataConditionsMaleFactorSpecific from "./conditions/male-factor-specific.json";
import dataConditionsLutealPhaseDefect from "./conditions/luteal-phase-defect.json";
import dataConditionsCervicalStenosis from "./conditions/cervical-stenosis.json";
import dataConditionsFr from "./conditions/fr.json";

export const contentDataFiles: { path: string; data: unknown }[] = [
  { path: "testing/semen-analysis.json", data: dataTestingSemenAnalysis },
  { path: "testing/amh.json", data: dataTestingAmh },
  { path: "testing/pgt-a.json", data: dataTestingPgtA },
  { path: "testing/pgt-a-products.json", data: dataTestingPgtAProducts },
  { path: "testing/era.json", data: dataTestingEra },
  { path: "testing/whole-genome.json", data: dataTestingWholeGenome },
  { path: "testing/fertility-tracker.json", data: dataTestingFertilityTracker },
  {
    path: "testing/monitoring-ultrasound.json",
    data: dataTestingMonitoringUltrasound,
  },
  {
    path: "testing/baseline-ultrasound.json",
    data: dataTestingBaselineUltrasound,
  },
  { path: "testing/general-bloodwork.json", data: dataTestingGeneralBloodwork },
  {
    path: "testing/comprehensive-biomarker-panel.json",
    data: dataTestingComprehensiveBiomarkerPanel,
  },
  { path: "testing/beta-hcg-test.json", data: dataTestingBetaHcgTest },
  {
    path: "testing/progesterone-check.json",
    data: dataTestingProgesteroneCheck,
  },
  { path: "testing/saline-sonogram.json", data: dataTestingSalineSonogram },
  { path: "testing/lining-check.json", data: dataTestingLiningCheck },
  { path: "testing/thyroid-panel.json", data: dataTestingThyroidPanel },
  { path: "testing/prolactin.json", data: dataTestingProlactin },
  { path: "testing/fsh-test.json", data: dataTestingFshTest },
  { path: "testing/lh-test.json", data: dataTestingLhTest },
  { path: "testing/estradiol-test.json", data: dataTestingEstradiolTest },
  { path: "testing/vitamin-d.json", data: dataTestingVitaminD },
  { path: "testing/cbc.json", data: dataTestingCbc },
  {
    path: "testing/infectious-disease-panel.json",
    data: dataTestingInfectiousDiseasePanel,
  },
  {
    path: "testing/thrombophilia-panel.json",
    data: dataTestingThrombophiliaPanel,
  },
  { path: "testing/karyotype.json", data: dataTestingKaryotype },
  { path: "testing/carrier-screening.json", data: dataTestingCarrierScreening },
  {
    path: "testing/preimplantation-genetic-testing.json",
    data: dataTestingPreimplantationGeneticTesting,
  },
  { path: "testing/pgt-m.json", data: dataTestingPgtM },
  { path: "testing/pgt-sr.json", data: dataTestingPgtSr },
  { path: "testing/pgt-p.json", data: dataTestingPgtP },
  { path: "testing/emma.json", data: dataTestingEmma },
  { path: "testing/alice.json", data: dataTestingAlice },
  { path: "testing/endometrio.json", data: dataTestingEndometrio },
  { path: "testing/afc.json", data: dataTestingAfc },
  {
    path: "testing/fertility-data-points.json",
    data: dataTestingFertilityDataPoints,
  },
  { path: "testing/fr.json", data: dataTestingFr },
  { path: "optimization/egg-quality.json", data: dataOptimizationEggQuality },
  {
    path: "optimization/sperm-optimization.json",
    data: dataOptimizationSpermOptimization,
  },
  { path: "optimization/supplements.json", data: dataOptimizationSupplements },
  { path: "optimization/alphasperm.json", data: dataOptimizationAlphasperm },
  {
    path: "optimization/supplements.fr.json",
    data: dataOptimizationSupplementsFr,
  },
  { path: "optimization/therapies.json", data: dataOptimizationTherapies },
  { path: "prep/from-couch.json", data: dataPrepFromCouch },
  { path: "prep/at-lab.json", data: dataPrepAtLab },
  { path: "prep/at-clinic.json", data: dataPrepAtClinic },
  { path: "products/at-home-tests.json", data: dataProductsAtHomeTests },
  {
    path: "program-modules/female-hormone-baseline.json",
    data: dataProgramModulesFemaleHormoneBaseline,
  },
  {
    path: "program-modules/male-fertility-baseline.json",
    data: dataProgramModulesMaleFertilityBaseline,
  },
  {
    path: "program-modules/female-optimization.json",
    data: dataProgramModulesFemaleOptimization,
  },
  {
    path: "program-modules/male-optimization.json",
    data: dataProgramModulesMaleOptimization,
  },
  {
    path: "program-modules/ovarian-stimulation.json",
    data: dataProgramModulesOvarianStimulation,
  },
  {
    path: "program-modules/egg-retrieval.json",
    data: dataProgramModulesEggRetrieval,
  },
  {
    path: "program-modules/fertilization-culture.json",
    data: dataProgramModulesFertilizationCulture,
  },
  {
    path: "program-modules/pgt-a-screening.json",
    data: dataProgramModulesPgtAScreening,
  },
  {
    path: "program-modules/embryo-transfer.json",
    data: dataProgramModulesEmbryoTransfer,
  },
  {
    path: "program-modules/iui-procedure.json",
    data: dataProgramModulesIuiProcedure,
  },
  {
    path: "program-modules/tww-support.json",
    data: dataProgramModulesTwwSupport,
  },
  {
    path: "program-modules/genetic-carrier.json",
    data: dataProgramModulesGeneticCarrier,
  },
  {
    path: "program-modules/comprehensive-genomic.json",
    data: dataProgramModulesComprehensiveGenomic,
  },
  {
    path: "program-modules/comprehensive-wellness.json",
    data: dataProgramModulesComprehensiveWellness,
  },
  { path: "program-modules/fr.json", data: dataProgramModulesFr },
  {
    path: "programs/fertility-check-in.json",
    data: dataProgramsFertilityCheckIn,
  },
  { path: "programs/her-optimization.json", data: dataProgramsHerOptimization },
  { path: "programs/his-optimization.json", data: dataProgramsHisOptimization },
  {
    path: "programs/couples-optimization.json",
    data: dataProgramsCouplesOptimization,
  },
  { path: "programs/egg-freezing.json", data: dataProgramsEggFreezing },
  { path: "programs/embryo-freezing.json", data: dataProgramsEmbryoFreezing },
  { path: "programs/ivf-cycle.json", data: dataProgramsIvfCycle },
  { path: "programs/iui-cycle.json", data: dataProgramsIuiCycle },
  { path: "programs/fet-cycle.json", data: dataProgramsFetCycle },
  {
    path: "programs/genetic-screening.json",
    data: dataProgramsGeneticScreening,
  },
  { path: "programs/full-assessment.json", data: dataProgramsFullAssessment },
  { path: "programs/fr.json", data: dataProgramsFr },
  { path: "procedures/hsg.json", data: dataProceduresHsg },
  {
    path: "procedures/initial-consult.json",
    data: dataProceduresInitialConsult,
  },
  {
    path: "procedures/follow-up-consult.json",
    data: dataProceduresFollowUpConsult,
  },
  {
    path: "procedures/genetic-counseling.json",
    data: dataProceduresGeneticCounseling,
  },
  { path: "procedures/trigger-shot.json", data: dataProceduresTriggerShot },
  { path: "procedures/iui.json", data: dataProceduresIui },
  { path: "procedures/mini-ivf.json", data: dataProceduresMiniIvf },
  { path: "procedures/mock-transfer.json", data: dataProceduresMockTransfer },
  {
    path: "procedures/endometrial-biopsy.json",
    data: dataProceduresEndometrialBiopsy,
  },
  { path: "procedures/sperm-freeze.json", data: dataProceduresSpermFreeze },
  {
    path: "procedures/ovarian-stimulation.json",
    data: dataProceduresOvarianStimulation,
  },
  { path: "procedures/egg-retrieval.json", data: dataProceduresEggRetrieval },
  {
    path: "procedures/embryo-transfer.json",
    data: dataProceduresEmbryoTransfer,
  },
  {
    path: "procedures/frozen-embryo-transfer.json",
    data: dataProceduresFrozenEmbryoTransfer,
  },
  {
    path: "procedures/endometrial-preparation.json",
    data: dataProceduresEndometrialPreparation,
  },
  { path: "procedures/luteal-support.json", data: dataProceduresLutealSupport },
  { path: "procedures/two-week-wait.json", data: dataProceduresTwoWeekWait },
  {
    path: "procedures/fertilization-icsi.json",
    data: dataProceduresFertilizationIcsi,
  },
  { path: "procedures/embryo-culture.json", data: dataProceduresEmbryoCulture },
  {
    path: "procedures/embryo-biopsy-pgt.json",
    data: dataProceduresEmbryoBiopsyPgt,
  },
  {
    path: "procedures/cryopreservation.json",
    data: dataProceduresCryopreservation,
  },
  {
    path: "procedures/sperm-collection.json",
    data: dataProceduresSpermCollection,
  },
  { path: "procedures/hysteroscopy.json", data: dataProceduresHysteroscopy },
  { path: "procedures/laparoscopy.json", data: dataProceduresLaparoscopy },
  { path: "procedures/tese.json", data: dataProceduresTese },
  {
    path: "procedures/assisted-hatching.json",
    data: dataProceduresAssistedHatching,
  },
  { path: "procedures/myomectomy.json", data: dataProceduresMyomectomy },
  { path: "procedures/polypectomy.json", data: dataProceduresPolypectomy },
  {
    path: "procedures/endometrial-scratch.json",
    data: dataProceduresEndometrialScratch,
  },
  {
    path: "procedures/hormonal-testing.json",
    data: dataProceduresHormonalTesting,
  },
  { path: "procedures/std-testing.json", data: dataProceduresStdTesting },
  {
    path: "procedures/thyroid-testing.json",
    data: dataProceduresThyroidTesting,
  },
  { path: "procedures/urinalysis.json", data: dataProceduresUrinalysis },
  {
    path: "procedures/transabdominal-ultrasound.json",
    data: dataProceduresTransabdominalUltrasound,
  },
  {
    path: "procedures/transvaginal-ultrasound.json",
    data: dataProceduresTransvaginalUltrasound,
  },
  {
    path: "procedures/doppler-ultrasound.json",
    data: dataProceduresDopplerUltrasound,
  },
  {
    path: "procedures/hysterosonography.json",
    data: dataProceduresHysterosonography,
  },
  {
    path: "procedures/antral-follicle-count.json",
    data: dataProceduresAntralFollicleCount,
  },
  { path: "procedures/pelvic-mri.json", data: dataProceduresPelvicMri },
  { path: "procedures/karyotyping.json", data: dataProceduresKaryotyping },
  {
    path: "procedures/carrier-testing.json",
    data: dataProceduresCarrierTesting,
  },
  {
    path: "procedures/exome-genome-sequencing.json",
    data: dataProceduresExomeGenomeSequencing,
  },
  { path: "procedures/swab-test.json", data: dataProceduresSwabTest },
  { path: "procedures/pap-smear.json", data: dataProceduresPapSmear },
  {
    path: "procedures/surgical-sperm-retrieval.json",
    data: dataProceduresSurgicalSpermRetrieval,
  },
  {
    path: "procedures/testicular-biopsy.json",
    data: dataProceduresTesticularBiopsy,
  },
  { path: "moon-articles.json", data: dataMoonArticles },
  { path: "moon-articles.fr.json", data: dataMoonArticlesFr },
  { path: "moon-articles-guides.json", data: dataMoonArticlesGuides },
  { path: "moon-articles-guides.fr.json", data: dataMoonArticlesGuidesFr },
  { path: "moon-articles-donor.json", data: dataMoonArticlesDonor },
  { path: "moon-articles-donor.fr.json", data: dataMoonArticlesDonorFr },
  { path: "moon-articles-decisions.json", data: dataMoonArticlesDecisions },
  {
    path: "moon-articles-decisions.fr.json",
    data: dataMoonArticlesDecisionsFr,
  },
  { path: "moon-articles-science.json", data: dataMoonArticlesScience },
  { path: "moon-articles-science.fr.json", data: dataMoonArticlesScienceFr },
  { path: "moon-articles-costs.json", data: dataMoonArticlesCosts },
  { path: "moon-articles-costs.fr.json", data: dataMoonArticlesCostsFr },
  {
    path: "moon-articles-country-guides.json",
    data: dataMoonArticlesCountryGuides,
  },
  {
    path: "moon-articles-country-guides.fr.json",
    data: dataMoonArticlesCountryGuidesFr,
  },
  { path: "moon-articles-travel.json", data: dataMoonArticlesTravel },
  { path: "moon-articles-travel.fr.json", data: dataMoonArticlesTravelFr },
  { path: "new-articles-batch1.json", data: dataNewArticlesBatch1 },
  { path: "new-articles-batch1.fr.json", data: dataNewArticlesBatch1Fr },
  { path: "new-articles-batch2.json", data: dataNewArticlesBatch2 },
  { path: "new-articles-batch2.fr.json", data: dataNewArticlesBatch2Fr },
  { path: "new-articles-batch3.json", data: dataNewArticlesBatch3 },
  { path: "new-articles-batch3.fr.json", data: dataNewArticlesBatch3Fr },
  { path: "new-articles-batch4.json", data: dataNewArticlesBatch4 },
  { path: "new-articles-batch4.fr.json", data: dataNewArticlesBatch4Fr },
  {
    path: "medications/gonadotropins.json",
    data: dataMedicationsGonadotropins,
  },
  {
    path: "medications/gnrh-antagonists.json",
    data: dataMedicationsGnrhAntagonists,
  },
  { path: "medications/gnrh-agonists.json", data: dataMedicationsGnrhAgonists },
  { path: "medications/trigger-shots.json", data: dataMedicationsTriggerShots },
  {
    path: "medications/progesterone-support.json",
    data: dataMedicationsProgesteroneSupport,
  },
  { path: "medications/estrogen.json", data: dataMedicationsEstrogen },
  {
    path: "medications/oral-ovulation.json",
    data: dataMedicationsOralOvulation,
  },
  {
    path: "medications/anticoagulants.json",
    data: dataMedicationsAnticoagulants,
  },
  { path: "medications/other.json", data: dataMedicationsOther },
  {
    path: "medications/growth-hormone.json",
    data: dataMedicationsGrowthHormone,
  },
  {
    path: "medications/dexamethasone.json",
    data: dataMedicationsDexamethasone,
  },
  {
    path: "medications/thyroid-support.json",
    data: dataMedicationsThyroidSupport,
  },
  {
    path: "medications/bromocriptine.json",
    data: dataMedicationsBromocriptine,
  },
  { path: "medications/tamoxifen.json", data: dataMedicationsTamoxifen },
  { path: "medications/intralipid.json", data: dataMedicationsIntralipid },
  { path: "medications/cycle-control.json", data: dataMedicationsCycleControl },
  { path: "medications/immune.json", data: dataMedicationsImmune },
  { path: "medications/glp1.json", data: dataMedicationsGlp1 },
  { path: "medications/warfarin.json", data: dataMedicationsWarfarin },
  { path: "medications/folic-acid.json", data: dataMedicationsFolicAcid },
  { path: "conditions/reproductive.json", data: dataConditionsReproductive },
  { path: "conditions/endocrine.json", data: dataConditionsEndocrine },
  { path: "conditions/structural.json", data: dataConditionsStructural },
  { path: "conditions/male-factor.json", data: dataConditionsMaleFactor },
  { path: "conditions/autoimmune.json", data: dataConditionsAutoimmune },
  { path: "conditions/mullerian.json", data: dataConditionsMullerian },
  {
    path: "conditions/male-factor-specific.json",
    data: dataConditionsMaleFactorSpecific,
  },
  {
    path: "conditions/luteal-phase-defect.json",
    data: dataConditionsLutealPhaseDefect,
  },
  {
    path: "conditions/cervical-stenosis.json",
    data: dataConditionsCervicalStenosis,
  },
  { path: "conditions/fr.json", data: dataConditionsFr },
];
